import React, { useEffect, useState } from "react";
import "./employee.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import CredentialsPopup from "../components/CredentialsPopup";
import {
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Switch,
    FormControlLabel,
    Typography,
    Button,
    Box
} from '@mui/material';
import { message } from "antd";
import APIURL from "../api/apiClient";




const Employee = () => {

    const [showCredentialsPopup, setShowCredentialsPopup] = useState(false);
    // const [missingCredentials, setMissingCredentials] = useState(false);
    const [employee, setEmployee] = useState({
        title: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        gender: '',
        username: '',
        employee_id: '',
        password: '',
        profile_image: '',
        profilePreview: '',
        email_id: '',
        joining_date: '',
        mobile_number: '',
        emergency_contact_number: '',
        highest_qualification: '',
        date_of_birth: '',
        marital_status: '',
        blood_group: '',
        adhaar_number: '',
        bank_name: '',
        pan_number: '',
        aniversary_date: '',
        bank_account_number: '',
        bank_branch: '',
        ifsc_code: '',
        address: '',
        status: 1,

    })

    const navigate = useNavigate();
    const location = useLocation();

    // Extract credentials from URL if available
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const username = params.get("username") || "";
        const employee_id = params.get("employee_id") || "";
        const password = params.get("password") || "";

        if (username && password) {
            setEmployee((prev) => ({
                ...prev,
                username,
                employee_id,
                password,
            }));
        }
    }, [location.search]);




    const handleSaveCredentials = (credentials) => {
        console.log("Received credentials:", credentials);
        const updatedEmployee = {
            ...employee,
            username: credentials.username,
            employee_id: credentials.employee_id,
            password: credentials.password
        };
        setEmployee(updatedEmployee);
        setShowCredentialsPopup(false);
        // setMissingCredentials(false);
    };

    const handleChange = (e) => {
        const { name, type, files, value, checked } = e.target;

        if (type === "checkbox") {
            setEmployee((prevEmployee) => ({
                ...prevEmployee,
                [name]: checked ? 1 : 0,
            }))
        } else if (type === 'file') {
            if (name === 'profile_image') {
                const profileFile = files[0];
                if (profileFile) {
                    // Revoke the previous URL to free memory
                    if (employee.profilePreview) {
                        URL.revokeObjectURL(employee.profilePreview);
                    }
                    const profilePreview = URL.createObjectURL(profileFile);
                    setEmployee((prevEmployee) => ({
                        ...prevEmployee,
                        profile_image: profileFile,
                        profilePreview,
                    }));
                }
            }
        } else {
            setEmployee((prevEmployee) => ({
                ...prevEmployee,
                [name]: value,
            }));
        }

    };


    useEffect(() => {
        return () => {
            if (employee.profilePreview) {
                URL.revokeObjectURL(employee.profilePreview);
            }
        };
    }, [employee.profilePreview]);


const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const formData = new FormData();

    // Append all fields in the employee object
    Object.entries(employee).forEach(([field, value]) => {
      if (field === 'profile_image' && value instanceof File) {
        formData.append(field, value);
      } else if (value !== undefined && value !== null) {
        formData.append(field, value);
      }
    });

    // Debugging FormData
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    // Send the request
    let response = await APIURL.post('/insertemployee.php', formData, true);

    console.log('Server response:', response);

    // Handle case where response is string instead of JSON
    if (typeof response === "string") {
      try {
        response = JSON.parse(response.trim());
      } catch {
        response = { success: false, message: response };
      }
    }

    if (response.success) {
      message.success("Employee Updated Successfully");
      navigate('/employeemaster');
    } else {
      alert(`Form submission failed: ${response.error || response.message}`);
    }
  } catch (error) {
    console.error("Error submitting form:", error);
  }
};




    return (
        <div className="employee-master-container">
            <div className="card">
                <div className="card-header text-white d-flex justify-content-between align-items-center"
                    style={{
                        background: 'linear-gradient(15deg, #667eea 0%, #764ba2 100%)',
                        padding: '1rem 1.5rem',
                        border: 'none'
                    }}>
                    <h2 className="mb-0" style={{
                        color: 'white',
                        textShadow: '0 1px 2px rgba(0,0,0,0.2)',
                        fontWeight: '600'
                    }}>
                        Employee Master
                    </h2>
                    <button
                        type="button"
                        onClick={() => setShowCredentialsPopup(true)}
                        style={{
                            background: 'linear-gradient(15deg, #f6d365 0%, #fda085 100%)',
                            border: 'none',
                            color: '#333',
                            padding: '0.5rem 1.25rem',
                            borderRadius: '30px',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                        onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <i className="bi bi-key-fill me-2"></i>Set Employee Credentials
                    </button>
                </div>

                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        {/* Profile Image Section */}
                        <div className="border rounded col-md-4 p-1 mb-4">
                            <section className="profile-grid-container">
                                <label htmlFor="profile_image" className="label_profile">
                                    Add <br /><span>Profile Image</span>
                                    <input
                                        type="file"
                                        name="profile_image"
                                        id="profile_image"
                                        className="profile"
                                        onChange={handleChange}
                                    />
                                </label>
                                <div className="profile_image">
                                    {employee.profilePreview && (
                                        <img
                                            src={employee.profilePreview}
                                            alt="Profile"
                                            height={100}
                                            className="profile_img"
                                        />
                                    )}
                                </div>
                            </section>
                        </div>

                        {/* Basic Info */}
                        <div className="border rounded p-4 mb-4">
                            <h5 className="mb-4 border-bottom pb-2">Basic Information</h5>
                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Title</InputLabel>
                                        <Select
                                            name="title"
                                            value={employee.title}
                                            onChange={handleChange}
                                            label="Title"
                                        >
                                            <MenuItem value=""><em>Select</em></MenuItem>
                                            <MenuItem value="mr">Mr.</MenuItem>
                                            <MenuItem value="ms">Ms.</MenuItem>
                                            <MenuItem value="mrs">Mrs.</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className="col-md-3 m  b-3">
                                    <TextField
                                        name="first_name"
                                        label="First Name"
                                        value={employee.first_name}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                        required
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="middle_name"
                                        label="Middle Name"
                                        value={employee.middle_name}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="last_name"
                                        label="Last Name"
                                        value={employee.last_name}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <TextField
                                        name="email_id"
                                        label="Email"
                                        value={employee.email_id}
                                        onChange={handleChange}
                                        type="email"
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <TextField
                                        name="mobile_number"
                                        label="Mobile Number"
                                        value={employee.mobile_number}
                                        onChange={handleChange}
                                        type="number"
                                        fullWidth
                                        size="small"
                                        required
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <TextField
                                        name="emergency_contact_number"
                                        label="Emergency Mobile"
                                        value={employee.emergency_contact_number}
                                        onChange={handleChange}
                                        type="number"
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Designation</InputLabel>
                                        <Select
                                            name="role"
                                            value={employee.role}
                                            onChange={handleChange}
                                            label="Designation"
                                            required
                                        >
                                            <MenuItem value="employee">Employee</MenuItem>
                                            <MenuItem value="admin">Admin</MenuItem>
                                            <MenuItem value="staff">Staff</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className="col-md-4 mb-3 d-flex align-items-center">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="status"
                                                checked={employee.status}
                                                onChange={(e) =>
                                                    handleChange({
                                                        target: {
                                                            name: "status",
                                                            type: "checkbox",
                                                            checked: e.target.checked,
                                                        },
                                                    })
                                                }
                                            />
                                        }
                                        label="Status"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Personal Details */}
                        <div className="border rounded p-4 mb-4">
                            <h5 className="mb-4 border-bottom pb-2">Personal Details</h5>
                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="date_of_birth"
                                        label="Date of Birth"
                                        type="date"
                                        value={employee.date_of_birth}
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="aniversary_date"
                                        label="Anniversary Date"
                                        type="date"
                                        value={employee.aniversary_date}
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="highest_qualification"
                                        label="Highest Qualification"
                                        value={employee.highest_qualification}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Marital Status</InputLabel>
                                        <Select
                                            name="marital_status"
                                            value={employee.marital_status}
                                            onChange={handleChange}
                                            label="Marital Status"
                                        >
                                            <MenuItem value="married">Married</MenuItem>
                                            <MenuItem value="unmarried">Unmarried</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="blood_group"
                                        label="Blood Group"
                                        value={employee.blood_group}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Gender</InputLabel>
                                        <Select
                                            name="gender"
                                            value={employee.gender}
                                            onChange={handleChange}
                                            label="Gender"
                                        >
                                            <MenuItem value="male">Male</MenuItem>
                                            <MenuItem value="female">Female</MenuItem>
                                            <MenuItem value="other">Other</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className="col-md-6 mb-3">
                                    <TextField
                                        name="address"
                                        label="Address"
                                        value={employee.address}
                                        onChange={handleChange}
                                        multiline
                                        rows={2}
                                        fullWidth
                                        size="small"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Employment Details */}
                        <div className="border rounded p-4 mb-4">
                            <h5 className="mb-4 border-bottom pb-2">Employment Details</h5>
                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="joining_date"
                                        label="Joining Date"
                                        type="date"
                                        value={employee.joining_date}
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="bank_name"
                                        label="Bank Name"
                                        value={employee.bank_name}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="bank_account_number"
                                        label="Bank Account Number"
                                        value={employee.bank_account_number}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="bank_branch"
                                        label="Bank Branch"
                                        value={employee.bank_branch}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="ifsc_code"
                                        label="IFSC Code"
                                        value={employee.ifsc_code}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="pan_number"
                                        label="PAN Number"
                                        value={employee.pan_number}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <TextField
                                        name="adhaar_number"
                                        label="Aadhaar Number"
                                        value={employee.adhaar_number}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Submit */}
                        <div className="text-center mt-4">
                            <Button
                                type="submit"
                                variant="contained"
                                size="large"
                                color="primary"
                                startIcon={<i className="bi bi-save me-2"></i>}
                            >
                                Save Employee
                            </Button>
                        </div>
                    </form>

                </div>
            </div>

            {/* Credentials Popup */}
            {showCredentialsPopup && (
                <CredentialsPopup
                    onSave={handleSaveCredentials}
                    onClose={() => setShowCredentialsPopup(false)}
                />
            )}
        </div>
    );
};

export default Employee;
